import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import Styles from './FolderPreview.module.scss'
import { EmptyFolder } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/EmptyFolder'
import { PreviewUnavailable } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/PreviewUnavailable'

const ChildPreview = ({ filePreview, emptyClassName }: { filePreview?: string; emptyClassName?: string }) => {
  if (!filePreview) {
    return <PreviewUnavailable className={emptyClassName} />
  }

  return <img src={filePreview} alt="preview" className={Styles.image} />
}

export const FolderPreview = ({ file, emptyClassName }: FilePreviewProps) => {
  if (!file.children_preview_urls || file.children_preview_urls.length < 1) {
    return <EmptyFolder className={emptyClassName} />
  }

  return (
    <div className={Styles.preview}>
      {file.children_preview_urls.slice(0, 4).map((filePreview, index) => (
        <div key={`file-preview-${index}-${filePreview}`} className={Styles.childPreview}>
          <ChildPreview filePreview={filePreview} emptyClassName={Styles.emptyChile} />
        </div>
      ))}
    </div>
  )
}
